import 'swiper/swiper.scss'
import cn from 'classnames'
import { useDispatch, useSelector } from 'react-redux'

import style from '@src/pages/UserPageGame/UserPageGame.module.scss'
import { IndividualsPanel }
  from '@src/components/IndividualsPanel/IndividualsPanel'
import { Footer } from '@src/components/Footer/Footer'
import { selectGameData } from '@src/store/ducks/promotion/selectors'
import {
  useCallback, useEffect, useMemo, useState,
} from 'react'
import { AppDispatch } from '@src/store/store'
import { Modal } from '@src/components/common/Modal/Modal'
import { setPageTitle } from '@src/store/ducks/app/reducer'
import { GameForm } from '@src/pages/UserPageGame/GameForm'
import { getCurrentGameData } from '@src/store/ducks/user/thunks'
import FaqAccordion from '@src/components/Accordion/Accordion'
import { setIsSuccessGameForm } from '@src/store/ducks/user/reducer'
import { selectSubscriptionsIsSuccessGameForm } from '@src/store/ducks/user/selectors'

export type GameData = {
    title: string;
    banner: string;
    consentToProcessing: string;
    behaviorRules: string;
    faq: Record<string, string>;
    isPassed: boolean;
}
export const UserPageGame = () => {
  const dispatch = useDispatch<AppDispatch>()
  const gameData: GameData | {} = useSelector(selectGameData) as GameData
  const isSuccessGameForm = useSelector(selectSubscriptionsIsSuccessGameForm)
  const currentDate = new Date()
  const registrationDeadline = new Date('2024-02-11')

  const initialIsPassed = useMemo(() => (gameData && 'isPassed' in gameData ? gameData.isPassed : false), [gameData]); const [gameForm, setGameForm] = useState(initialIsPassed || false)
  useEffect(() => {
    dispatch(setPageTitle('Главная страница |Личный кабинет для абонентов КОСМОС Телеком'))
    dispatch(getCurrentGameData())
    dispatch(setIsSuccessGameForm(false))
  }, [dispatch])
  useEffect(() => {
    setGameForm(initialIsPassed)
  }, [initialIsPassed])

  const closeModal = useCallback(() => {
    dispatch(setIsSuccessGameForm(false))
    dispatch(getCurrentGameData())
  }, [dispatch])

  return (
    <div>
      <IndividualsPanel />
      <div className={cn(style.container, 'container')}>
        {/* <div> */}
        {/*  <SliderSwiper data={promotions.data} /> */}
        {/* </div> */}
        <div className={style.user_box}>
          <h1 className={style.headerBlock}>
            {gameData ? (gameData as GameData).title : ''}
          </h1>
          <div className={style.bodyBlock}>
            <div className={style.imageWrapper}>
              {gameData ? <img src={`${process.env.REACT_APP_SITE_URL}/${(gameData as GameData).banner}`} alt="" /> : null}
            </div>
            {(!gameForm && currentDate < registrationDeadline) ? (
              <GameForm
                consentToProcessing={(gameData as GameData).consentToProcessing}
                behaviorRules={(gameData as GameData).behaviorRules}
              />
            ) : (
              <>
                {gameForm && currentDate < registrationDeadline ? (
                  <>
                    Отлично! Вы уже участвуете!
                  </>
                ) : (
                  <div className={style.sucGameForm}>
                    {currentDate >= registrationDeadline && gameForm ? (
                      <>
                        Регистрация закрыта.
                        <br />
                        Отлично! Вы уже участвуете!
                      </>
                    ) : (
                      <>Регистрация закрыта.</>
                    )}
                  </div>
                )}
              </>
            )}
            <div className={style.faqBlock}>
              <h3>Вопросы и ответы</h3>
              <FaqAccordion faqArr={(gameData as GameData).faq} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <Modal isOpen={isSuccessGameForm} close={closeModal}>
        <>
          <div className={style.confirmActions}>
            Ваши данные были
            <span className="blue"> успешно сохранены</span>
            {' '}
          </div>
        </>
      </Modal>
    </div>
  )
}
